<div class="tab-pane" role="tabpanel" id="permisos">
    <fieldset id="agregar_perm_resol" class="">
        <div class="step_section">
            <h3 class="form-signin-heading"><strong>Permiso de demolici&oacute;n</strong></h3>
            <hr />
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal">
                            <div class="form-group" align="left">
                                <label for="perm_numero" class="col-md-2">N&uacute;mero permiso</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="N&uacute;mero Permiso" id="perm_numero" name="perm_numero" formControlName="perm_numero" (change)="add_permiso_demolicion()" >
                                        <mat-error *ngIf="form.controls['perm_numero'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>  
                                    </mat-form-field>
                                </div>
                                <label for="perm_fecha" class="col-md-1" style="padding-left: 30px;">Fecha</label>
                                <!-- <div class="col-md-2">
                                    <mat-form-field style="width: 145px">
                                        <input matInput [matDatepicker]="dp3" [max]="maxDate" formControlName="fecha_informe" (dateInput)="add_informe_revisor()" (dateChange)="add_informe_revisor()">
                                        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                        <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div> -->
                                <div class="col-md-2" style="padding-left: 40px;">
                                    <mat-form-field class="dateinput">
                                        <input matInput [matDatepicker]="dp3" [max]="maxDate" formControlName="perm_fecha" (dateInput)="add_permiso_demolicion($event,'input')" (dateChange)="add_permiso_demolicion($event,'input')">
                                        <mat-datepicker-toggle matSuffix [for]="dp3" disabled="false"></mat-datepicker-toggle>
                                        <mat-datepicker #dp3 ></mat-datepicker>
                                    </mat-form-field>
                                </div>

                            </div>
                            <div class="col-md-12" style="padding-top: 20px"></div>
                            <div class="form-group" align="left">
                                <label for="modproy" class="col-md-4">Solicitud conjunta con permiso de Edificaci&oacute;n o Ampliaci&oacute;n</label>
                                <div class="col-md-2 inline" style="padding-top: 20px;">
                                    <mat-radio-group formControlName="solicitud">
                                        <mat-radio-button style="padding-right: 20px" name="solicitud" (change)="add_permiso_demolicion()" value="SI">SI</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="solicitud" (change)="add_permiso_demolicion()" value="NO">NO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                
                             </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>